import type React from 'react';

import type { IconProps } from 'src/types/components';

export const IconRecommendations: React.FC<IconProps> = (props) => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M7.125 1.5H13.875L9.75 6.75H15.375L6.375 16.5L8.25 9.375H3L7.125 1.5Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
